<div class="app-loading-bar" *ngIf="isLoading$ | async" aria-hidden="true">
  <span></span>
</div>

<!-- Covers the app until the Microsoft bootstrap decides between dashboard and
     login, so neither screen flashes on the way there. -->
<div class="app-splash" *ngIf="!authResolved" role="status" aria-live="polite">
  <img src="assets/agricola/agricola-logo.svg" alt="Bancoagrícola" class="app-splash-logo">
  <span class="app-splash-spinner" aria-hidden="true"></span>
  <span class="app-splash-text">Verificando tu sesión…</span>
</div>

<router-outlet></router-outlet>
